import {
  ApplicationConfig,
  importProvidersFrom,
  APP_INITIALIZER,
  inject,
} from '@angular/core';
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth, Auth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { UserStateService } from './core/services/user-state.service';
import { UserManagementService } from './core/services/user-management.service';
import { NavigationService } from './core/services/navigation.service';
import { AuthInitializerService } from './features/auth/services/auth-initializer.service';

/** UK date-only format (time is chosen in separate hour/minute fields). */
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// Factory function to initialize Firebase Auth before app starts
function initializeFirebaseAuth() {
  return () => {
    console.log('APP_INITIALIZER: Starting Firebase Auth initialization');
    const authInitializer = inject(AuthInitializerService);
    return authInitializer.initializeAuth();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules), // Preload all modules for better performance
    ),
    provideAnimations(),
    provideHttpClient(withXhr()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    // Admin is often multi-tab; skip IndexedDB persistence (deprecated enableIndexedDbPersistence removed).
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions()),
    provideMomentDateAdapter(MY_DATE_FORMATS),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    // Provide our custom services
    UserStateService,
    UserManagementService,
    NavigationService,
    // Initialize Firebase Auth before anything else
    {
      provide: APP_INITIALIZER,
      useFactory: initializeFirebaseAuth,
      multi: true,
    },
  ],
};
